import { render, staticRenderFns } from "./app-course-detail-coupon.vue?vue&type=template&id=dcd1730a"
import script from "./app-course-detail-coupon.vue?vue&type=script&lang=js"
export * from "./app-course-detail-coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports